var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTensoliteEstructuras(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e2e2e2;}.cls-2{fill:#818282;}.cls-3{fill:#cfcfcf;}.cls-4{clip-path:url(#clippath-1);}.cls-5{clip-path:url(#clippath);}.cls-6{fill:none;}.cls-7{fill:#e8e8e8;}.cls-8{fill:#c3c2c2;}.cls-9{fill:#b5b4b5;}.cls-10{fill:#a8a8a8;}.cls-11{fill:#919191;}.cls-12{fill:#9c9b9b;}.cls-13{fill:#888;}.cls-14{fill:#b9b9b9;}.cls-15{fill:#dfdfdf;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 540,
    cy: 548.78,
    r: 432.68
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 540,
    cy: 548.78,
    r: 432.68
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540,
    cy: 548.78,
    r: 432.68
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "179.83 828.5 190.61 835 190.61 599.17 179.83 592.67 179.83 828.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "393.66 724.65 383.51 718.53 383.51 954.35 393.66 960.47 393.66 724.65"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 248.43,
    y1: 902.81,
    x2: 329.68,
    y2: 948.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "459.77 978.23 1044.12 644.27 1044.12 422.21 459.77 756.18 459.77 978.23"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "742.1 593.99 751.44 588.7 751.44 810.76 742.1 816.05 742.1 593.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "550.24 702.71 559.12 697.68 559.12 919.73 550.24 924.77 550.24 702.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "454.06 757.21 463.43 751.9 463.43 973.95 454.06 979.26 454.06 757.21"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "926.31 482.5 935.47 477.32 935.47 699.37 926.31 704.56 926.31 482.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "452.17 1018.25 1036.52 684.29 1036.52 643.65 452.17 977.62 452.17 1018.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1054.14 416.68 454.74 760.47 454.74 737.02 1054.14 401.17 1054.14 416.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1053.63 404.36 464.29 743.61 279.66 538.27 852.67 202.51 1053.63 404.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "669.92 200.78 109.2 528.58 297.39 530.33 856.35 202.08 669.92 200.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "330.08 735.55 248.83 689.61 248.83 901.31 330.08 947.24 330.08 735.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "320.58 743.07 257.53 707.42 257.53 907.73 320.58 943.38 320.58 743.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M604.54,707.28h0c-6.26,3.51-10.13,10.12-10.13,17.29v38.65l21.82-12.51v-36.6c0-5.99-6.46-9.76-11.69-6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M697.28,649.46h0c-6.26,3.51-10.13,10.12-10.13,17.29v38.65l21.82-12.51v-36.6c0-5.99-6.46-9.76-11.69-6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M796.97,594.95h0c-6.26,3.51-10.13,10.12-10.13,17.29v38.65l21.82-12.51v-36.6c0-5.99-6.46-9.76-11.69-6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M890.49,546.88h0c-6.26,3.51-10.13,10.12-10.13,17.29v38.65l21.82-12.51v-36.6c0-5.99-6.46-9.76-11.69-6.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "451.25 1017.85 102.46 827.6 102.46 786.96 451.25 977.22 451.25 1017.85"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "179.83 828.5 190.61 835 190.61 599.17 179.83 592.67 179.83 828.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "393.66 724.65 383.51 718.53 383.51 954.35 393.66 960.47 393.66 724.65"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 248.43,
    y1: 902.81,
    x2: 329.68,
    y2: 948.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "459.77 978.23 1044.12 644.27 1044.12 422.21 459.77 756.18 459.77 978.23"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "742.1 593.99 751.44 588.7 751.44 810.76 742.1 816.05 742.1 593.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "550.24 702.71 559.12 697.68 559.12 919.73 550.24 924.77 550.24 702.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "454.06 757.21 463.43 751.9 463.43 973.95 454.06 979.26 454.06 757.21"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "926.31 482.5 935.47 477.32 935.47 701.25 926.31 706.44 926.31 482.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "452.17 1018.25 1036.52 684.29 1036.52 643.65 452.17 977.62 452.17 1018.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1053.63 404.36 464.29 743.61 297.39 530.33 869.5 194.57 1053.63 404.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "330.08 735.55 248.83 689.61 248.83 901.31 330.08 947.24 330.08 735.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "320.58 743.07 257.53 707.42 257.53 907.73 320.58 943.38 320.58 743.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M604.54,707.28h0c-6.26,3.51-10.13,10.12-10.13,17.29v38.65l21.82-12.51v-36.6c0-5.99-6.46-9.76-11.69-6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M697.28,649.46h0c-6.26,3.51-10.13,10.12-10.13,17.29v38.65l21.82-12.51v-36.6c0-5.99-6.46-9.76-11.69-6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M796.97,594.95h0c-6.26,3.51-10.13,10.12-10.13,17.29v38.65l21.82-12.51v-36.6c0-5.99-6.46-9.76-11.69-6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M890.49,546.88h0c-6.26,3.51-10.13,10.12-10.13,17.29v38.65l21.82-12.51v-36.6c0-5.99-6.46-9.76-11.69-6.83Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "110.83 561.58 110.83 785.45 460.85 982.11 460.85 758.24 110.83 561.58"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "187.67 827.65 198.38 834.15 198.38 598.33 187.67 591.83 187.67 827.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "400.05 723.8 389.97 717.68 389.97 953.51 400.05 959.63 400.05 723.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "120.21 553.16 110.83 547.47 110.83 783.29 120.21 788.99 120.21 553.16"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 254.82,
    y1: 900.48,
    x2: 336.08,
    y2: 946.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M880.98,693.66c-13.11-56.53-7.27-116.52-4.64-174.23l-410.17,234.42v222.06l414.02-236.62c-.05-15.2,.21-30.41,.79-45.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "748.5 591.67 757.84 586.38 757.84 808.43 748.5 813.73 748.5 591.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "556.63 700.39 565.51 695.35 565.51 917.41 556.63 922.44 556.63 700.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "460.46 754.88 469.82 749.57 469.82 971.63 460.46 976.94 460.46 754.88"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "460.46 758.02 109.06 561.58 109.06 536.43 460.46 736.04 460.46 758.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M881.22,732.41l-421.6,240.95v40.64l422.35-241.38c-.53-13.38-.77-26.78-.75-40.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M876.94,504.33c1.7-51.48-4.19-106.75,2.43-158.95-39.53-13.23-79.43-25.3-119.93-34.63-26.16-1.33-52.32-3.48-78.45-6.21l-394.94,231.42,184.63,205.34,413.08-239.14c.04-1.06-6.86,3.24-6.82,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M297.39,530.33l181.02,202.28-6.02,10.2L109.2,536.81v-8.23l188.19,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M529.94,282.91L110.1,528.58l187.29,1.75,384.39-225.8c-50.99-5.31-101.61-12.86-151.84-21.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "336.48 733.22 255.22 687.29 255.22 898.98 336.48 944.92 336.48 733.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M610.94,704.96h0c-6.26,3.51-10.13,10.12-10.13,17.29v38.65l21.82-12.51v-36.6c0-5.99-6.46-9.76-11.69-6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M703.67,647.14h0c-6.26,3.51-10.13,10.12-10.13,17.29v38.65l21.82-12.51v-36.6c0-5.99-6.46-9.76-11.69-6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M803.37,592.62h0c-6.26,3.51-10.13,10.12-10.13,17.29v38.65l21.82-12.51v-36.6c0-5.99-6.46-9.76-11.69-6.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "108.9 536.81 471.69 742.64 291.93 541.08 108.9 536.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "459.62 1013.99 110.83 823.74 110.83 783.1 459.62 973.36 459.62 1013.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "326.98 740.75 263.92 705.1 263.92 907.24 326.98 941.64 326.98 740.75"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "944.8 467.08 475.19 736.47 472.39 741.22 460.46 734.45 460.46 756.43 965.02 465.73 944.8 467.08"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0,
    width: 1080,
    height: 1080
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensoliteEstructuras);
export default __webpack_public_path__ + "static/media/Tensolite Estructuras.5dc4dabedacd074fb7dc9e61ce21ddd7.svg";
export { ForwardRef as ReactComponent };